import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../auth/authContext';
import { AuthService } from '../auth/authService';
import { LoadingSpinner } from '../components/LoadingSpinner';
export const AuthCallback = () => {
    const navigate = useNavigate();
    const { refreshUser } = useAuth();
    const [searchParams] = useSearchParams();
    useEffect(() => {
        const handleCallback = async () => {
            console.log('[AuthCallback] Starting OAuth callback handler');
            console.log('[AuthCallback] URL:', window.location.href);
            // Check if we have auth code from Cognito
            const code = searchParams.get('code');
            const error = searchParams.get('error');
            const errorDescription = searchParams.get('error_description');
            console.log('[AuthCallback] Code:', code?.substring(0, 20) + '...');
            console.log('[AuthCallback] Error:', error);
            console.log('[AuthCallback] Error description:', errorDescription);
            if (error) {
                console.error('[AuthCallback] Auth error from Cognito:', error, errorDescription);
                navigate('/login', { replace: true });
                return;
            }
            if (!code) {
                console.error('[AuthCallback] No authorization code received');
                navigate('/login', { replace: true });
                return;
            }
            // Exchange the authorization code for tokens
            console.log('[AuthCallback] Exchanging code for tokens...');
            const success = await AuthService.exchangeCodeForTokens(code);
            if (!success) {
                console.error('[AuthCallback] Failed to exchange authorization code for tokens');
                navigate('/login', { replace: true });
                return;
            }
            // Tokens are now stored, refresh auth state to update context
            console.log('[AuthCallback] Token exchange successful, refreshing auth state...');
            await refreshUser();
            // Now redirect to dashboard
            console.log('[AuthCallback] Auth state updated, redirecting to dashboard');
            navigate('/dashboard', { replace: true });
        };
        handleCallback();
    }, [navigate, searchParams, refreshUser]);
    return _jsx(LoadingSpinner, {});
};
//# sourceMappingURL=AuthCallback.js.map